import * as React from "react";
import { forwardRef } from "react";
const SvgBack = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M17.625 10H3.875", stroke: "#151515", strokeWidth: 1.6, strokeLinecap: "square", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8.625 4.375L3 10L8.625 15.625", stroke: "#151515", strokeWidth: 1.6, strokeLinecap: "square", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgBack);
export default ForwardRef;
